export enum PrivacyItemType {
  Checkbox = 'checkbox',
  Radio = 'radio',
  Text = 'text',
}
